/**
 * Created by r4zi4l on 09.02.2021
 */

const Map2dAdviceMineLogic = function (options) {
    Map2dAdviceBaseLogic.call(this, options);

    options = options || {};
    this.monster = options.monster;
};

Map2dAdviceMineLogic.prototype = Object.create(Map2dAdviceBaseLogic.prototype);
Map2dAdviceMineLogic.prototype.constructor = Map2dAdviceMineLogic;

Map2dAdviceMineLogic.prototype.findMove = function () {
    if (this.monster) {
        return this.findMonsterMove();
    }

    if (!Map2d.currentMap.workers.findFree()) {
        return;
    }

    const mineable = this.listAvailableUnits().map((unit) => unit.findComponent(Mineable)).filter((mineable) => {
        if (mineable && mineable.state === Mineable.STATES.WAIT && !Map2d.currentMap.workers.findAssigned(mineable.unit)) {
            return !this.targets || this.targets.some((target) => target.mined === undefined || target.mined === mineable.mined);
        }
        return false;
    }).sort((a, b) => b.mined - a.mined)[0];

    if (mineable) {
        const cell = cc.p(mineable.unit.x, mineable.unit.y);
        const infoOpen = InfoView.IsDisplayedFor(mineable.unit);
        const tutorialTarget = Map2dLocation.currentLocation.tutorial.checkConditions({ unit: mineable.unit }) || cleverapps.tutorial.checkConditions({ unit: mineable.unit });
        return {
            cells: [cell],
            highlight: !infoOpen && tutorialTarget && [cell],
            outline: !infoOpen && tutorialTarget && cell,
            arrow: !infoOpen && cell,
            unitView: infoOpen && ["energy"]
        };
    }
};

Map2dAdviceMineLogic.prototype.findMonsterMove = function () {
    const monsters = [];

    const region = Map2d.currentMap.regions.monsters;
    for (let i = 0; i < region.positions.length; i++) {
        const monster = Map2d.currentMap.getUnit(region.positions[i].x, region.positions[i].y);
        const info = monster && monster.getActionInfo();
        if (monster && monster.getData().monster === this.monster && this.isApplicable(monster)
            && info && info.buttons.wands.wands <= Map2dLocation.currentLocation.wands) {
            monsters.push(monster);
        }
    }

    const target = monsters[0];
    const infoOpen = InfoView.IsDisplayedFor(target);
    const cell = cc.p(target.x, target.y);
    if (target) {
        return {
            cells: [cell],
            highlight: !infoOpen && [cell],
            unitView: infoOpen && ["wandsAttack"]
        };
    }
};